<template>

<core-panel>

	<template v-slot:head>

		<h1 v-if="band < 6">{{ band }} players</h1>
		<h1 v-if="band === 6">{{ band }}+ players</h1>

		<p v-if="!isRatio">The people with most plays at this count.</p>
		<p v-if="isRatio">The people with highest ratio of plays at this count.</p>

	</template>

	<template v-slot:body>

        <template v-if="isRatio">

            <app-user type="player" :item="item" v-for="item in players" :subtext="item.count + ' plays'" count-field="ratio" count-percent="true" :key="'t' + item.key" />

		</template>

		<template v-if="!isRatio">

			<app-user type="player" :item="item" v-for="item in players" :subtext="item.ratio + '% of their plays'" count-text="play" :key="'r' + item.key" />

		</template>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'count',
			players: []
		}

	},

    computed: {

        isRatio: function() {

            return this.$store.getters['filter/insights/players/count/sort'] === 'ratio'

        },

        band: function() {

            return this.$store.getters['filter/insights/players/count/band']

        }

    },

	methods: {

		response: function(json) {

			this.players = json.counts.players

		}

	}

}

</script>